// extracted by mini-css-extract-plugin
export default {"container":"style_container__Gc9sz","img":"style_img__ltDwS","title":"style_title__4pklh"};